import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Chart from 'react-apexcharts';
//import { useDispatch, useSelector } from 'react-redux';

import {
  TrendingUp,
  TrendingDown,
  ShoppingBag,
  Truck,
  Users,
  Package,
  RefreshCw,

  CheckCircle,
  Clock,
  Calendar,
  ArrowUp,
  ArrowDown,
  MapPin,

} from 'feather-icons-react/build/IconComponents';
import { dashboardActions } from '../../core/action/dashboardActions';
//import { all_routes } from '../../Router/all_routes';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';


const MySwal = withReactContent(Swal);

const Dashboard = () => {
  //const route = all_routes;
  //const dispatch = useDispatch();
  //const data = useSelector((state) => state.toggle_header);

  // State
  const [dashboardData, setDashboardData] = useState({
    totalRevenue: 0,
    revenueGrowth: 0,
    totalSalesReturn: 0,
    salesReturnGrowth: 0,
    totalPurchase: 0,
    purchaseGrowth: 0,
    totalPurchaseReturn: 0,
    purchaseReturnGrowth: 0,
    totalProfit: 0,
    profitGrowth: 0,
    totalExpenses: 0,
    expenseGrowth: 0,
    totalSales: 0,
    salesGrowth: 0,
    totalSuppliers: 0,
    totalCustomers: 0,
    totalOrders: 0,
    newCustomers: 0,
    returningCustomers: 0,
    bankAccounts: 0,
    monthlySales: [],
    monthlyPurchases: [],
    topSellingProducts: [],
    lowStockProducts: [],
    recentSales: [],
    recentTransactions: [],
    topCustomers: [],
    categoryStats: {
      totalCategories: 0,
      totalProducts: 0
    },
    salesPaymentSummary: {
      totalPaid: 0,
      totalDue: 0,
      totalInvoiced: 0,
      totalOrders: 0,
      avgOrderValue: 0,
      collectionRate: 0,
      paidOrders: 0,
      partialOrders: 0,
      unpaidOrders: 0,
      pendingOrders: 0,
      deliveredOrders: 0,
      cancelledOrders: 0
    }
  });

  const [loading, setLoading] = useState(true);
  const [selectedPeriod, setSelectedPeriod] = useState('weekly');
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount || 0);
  };

  // Format compact number (e.g., 1.2K, 3.5M)
  const formatCompactNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
  };

  // Load dashboard data from API
  const loadDashboardData = useCallback(async () => {
    try {
      setLoading(true);

      // Fetch main dashboard data
      const result = await dashboardActions.getDashboardData({
        year: selectedYear,
        month: selectedMonth
      });

      if (result.success && result.data) {
        setDashboardData(result.data);
      } else {
        // If API fails, show error but don't use hardcoded data
        MySwal.fire({
          icon: 'error',
          title: 'Error',
          text: result.message || 'Failed to load dashboard data',
          timer: 3000,
          showConfirmButton: false
        });
      }
    } catch (error) {
      console.error('Error loading dashboard:', error);
      MySwal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to load dashboard data',
        timer: 3000,
        showConfirmButton: false
      });
    } finally {
      setLoading(false);
    }
  }, [selectedYear, selectedMonth]);

  // Load data on mount and when filters change
  useEffect(() => {
    loadDashboardData();
  }, [loadDashboardData]);

  // Chart options for Sales & Purchase
  const salesPurchaseChartOptions = {
    series: [
      {
        name: 'Total Purchase',
        data: dashboardData.monthlyPurchases?.length ? dashboardData.monthlyPurchases : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: 'Total Sales',
        data: dashboardData.monthlySales?.length ? dashboardData.monthlySales : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }
    ],
    colors: ['#FF9F43', '#28C76F'],
    chart: {
      type: 'area',
      height: 300,
      stacked: false,
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    dataLabels: { enabled: false },
    stroke: {
      curve: 'smooth',
      width: 3
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.5,
        opacityTo: 0.1,
        stops: [0, 90, 100]
      }
    },
    markers: {
      size: 4,
      colors: ['#FF9F43', '#28C76F'],
      strokeColors: '#fff',
      strokeWidth: 2,
      hover: {
        size: 6
      }
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      labels: {
        style: {
          colors: '#9aa4af',
          fontSize: '12px'
        }
      }
    },
    yaxis: {
      labels: {
        formatter: (value) => formatCompactNumber(value * 1000), // Convert back from K
        style: {
          colors: '#9aa4af',
          fontSize: '12px'
        }
      }
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -20,
      fontSize: '13px',
      markers: {
        width: 12,
        height: 12,
        radius: 6
      }
    },
    tooltip: {
      y: {
        formatter: (value) => formatCurrency(value * 1000)
      }
    },
    grid: {
      borderColor: '#f0f2f5',
      strokeDashArray: 5
    }
  };

  // Sales Statistics Chart (Pie)
  // const salesStatsChartOptions = {
  //   series: [dashboardData.totalSales || 0, dashboardData.totalExpenses || 0],
  //   chart: {
  //     type: 'donut',
  //     height: 250
  //   },
  //   labels: ['Revenue', 'Expenses'],
  //   colors: ['#28C76F', '#EA5455'],
  //   plotOptions: {
  //     pie: {
  //       donut: {
  //         size: '70%',
  //         labels: {
  //           show: true,
  //           total: {
  //             show: true,
  //             label: 'Total',
  //             formatter: () => formatCurrency((dashboardData.totalSales || 0) + (dashboardData.totalExpenses || 0))
  //           }
  //         }
  //       }
  //     }
  //   },
  //   dataLabels: { enabled: false },
  //   legend: {
  //     position: 'bottom',
  //     fontSize: '13px',
  //     markers: {
  //       width: 10,
  //       height: 10,
  //       radius: 5
  //     }
  //   },
  //   tooltip: {
  //     y: {
  //       formatter: (value) => formatCurrency(value)
  //     }
  //   },
  //   responsive: [{
  //     breakpoint: 480,
  //     options: {
  //       chart: {
  //         height: 200
  //       },
  //       legend: {
  //         position: 'bottom'
  //       }
  //     }
  //   }]
  // };

  // Quick action items
  // const quickActions = [
  //   { icon: <ShoppingBag size={20} />, label: 'New Sale', color: 'success', link: route.addsales, bg: 'bg-success' },
  //   { icon: <Truck size={20} />, label: 'New Purchase', color: 'primary', link: route.addpurchase, bg: 'bg-primary' },
  //   { icon: <Package size={20} />, label: 'Add Product', color: 'info', link: route.addproduct, bg: 'bg-info' },
  //   { icon: <Users size={20} />, label: 'Add Customer', color: 'warning', link: route.addcustomer, bg: 'bg-warning' },
  //   { icon: <FileText size={20} />, label: 'Add Expense', color: 'danger', link: '/expenses', bg: 'bg-danger' }
  // ];

  // Handle refresh
  const handleRefresh = () => {
    loadDashboardData();
  };

  // Handle year change
  const handleYearChange = (e) => {
    setSelectedYear(parseInt(e.target.value));
  };

  // Handle month change
  const handleMonthChange = (e) => {
    setSelectedMonth(parseInt(e.target.value));
  };

  // Handle period change for top products
  const handlePeriodChange = (period) => {
    setSelectedPeriod(period);
    // You can fetch period-specific data here
  };

  // Get status badge class
  const getStatusBadge = (status) => {
    const classes = {
      'Completed': 'bg-success',
      'Pending': 'bg-warning',
      'Cancelled': 'bg-danger',
      'paid': 'bg-success',
      'unpaid': 'bg-warning',
      'pending': 'bg-warning'
    };
    return classes[status] || 'bg-secondary';
  };

  if (loading && !dashboardData.totalRevenue) {
    return (
      <div className="page-wrapper">
        <div className="content d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <h5 className="text-muted">Loading Dashboard...</h5>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Header with Welcome Message and Filters */}
        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
          <div>
            <h2 className="mb-1">Welcome, Admin</h2>
            <p className="text-muted">You have {dashboardData.totalOrders || 0} Orders, Today</p>
          </div>
          <div className="d-flex gap-2 flex-wrap">
            <div className="d-flex gap-2">
              <select
                className="form-select form-select-sm"
                style={{ width: '100px' }}
                value={selectedMonth}
                onChange={handleMonthChange}
              >
                <option value="1">Jan</option>
                <option value="2">Feb</option>
                <option value="3">Mar</option>
                <option value="4">Apr</option>
                <option value="5">May</option>
                <option value="6">Jun</option>
                <option value="7">Jul</option>
                <option value="8">Aug</option>
                <option value="9">Sep</option>
                <option value="10">Oct</option>
                <option value="11">Nov</option>
                <option value="12">Dec</option>
              </select>
              <select
                className="form-select form-select-sm"
                style={{ width: '100px' }}
                value={selectedYear}
                onChange={handleYearChange}
              >
                <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
                <option value={new Date().getFullYear() - 1}>{new Date().getFullYear() - 1}</option>
                <option value={new Date().getFullYear() - 2}>{new Date().getFullYear() - 2}</option>
              </select>
            </div>
            <button className="btn btn-outline-light d-flex align-items-center gap-2">
              <Calendar size={16} />
              <span>{new Date().toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
            </button>
            <button className="btn btn-outline-light d-flex align-items-center gap-2" onClick={handleRefresh}>
              <RefreshCw size={16} />
              <span>Refresh</span>
            </button>
          </div>
        </div>

        {/* KPI Cards Row 1 - Financial */}
        <div className="row g-3 mb-4">
          {/* Total Sales */}
          <div className="col-xl-3 col-sm-6">
            <div className="card bg-gradient-primary border-0">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <p className="text-white-50 mb-1">Total Sales</p>
                    <h3 className="text-white mb-0">{formatCurrency(dashboardData.totalRevenue)}</h3>
                  </div>
                  <div className="bg-light bg-opacity-25 rounded p-2">
                    <TrendingUp size={24} className="text-white" />
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <span className="badge bg-light text-success fw-semibold me-2">
                    <ArrowUp size={14} className="me-1" />
                    {dashboardData.revenueGrowth || 0}%
                  </span>
                  <span className="text-white-50 small">vs last month</span>
                </div>
              </div>
            </div>
          </div>

          {/* Total Sales Return */}
          <div className="col-xl-3 col-sm-6">
            <div className="card bg-gradient-danger border-0">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <p className="text-white-50 mb-1">Total Sales Return</p>
                    <h3 className="text-white mb-0">{formatCurrency(dashboardData.totalSalesReturn)}</h3>
                  </div>
                  <div className="bg-light bg-opacity-25 rounded p-2">
                    <TrendingDown size={24} className="text-white" />
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <span className="badge bg-light text-danger fw-semibold me-2">
                    <ArrowDown size={14} className="me-1" />
                    {Math.abs(dashboardData.salesReturnGrowth || 0)}%
                  </span>
                  <span className="text-white-50 small">vs last month</span>
                </div>
              </div>
            </div>
          </div>

          {/* Total Purchase */}
          <div className="col-xl-3 col-sm-6">
            <div className="card bg-gradient-warning border-0">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <p className="text-white-50 mb-1">Total Purchase</p>
                    <h3 className="text-white mb-0">{formatCurrency(dashboardData.totalPurchase)}</h3>
                  </div>
                  <div className="bg-light bg-opacity-25 rounded p-2">
                    <ShoppingBag size={24} className="text-white" />
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <span className="badge bg-light text-warning fw-semibold me-2">
                    <ArrowUp size={14} className="me-1" />
                    {dashboardData.purchaseGrowth || 0}%
                  </span>
                  <span className="text-white-50 small">vs last month</span>
                </div>
              </div>
            </div>
          </div>

          {/* Total Purchase Return */}
          <div className="col-xl-3 col-sm-6">
            <div className="card bg-gradient-info border-0">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div>
                    <p className="text-white-50 mb-1">Total Purchase Return</p>
                    <h3 className="text-white mb-0">{formatCurrency(dashboardData.totalPurchaseReturn)}</h3>
                  </div>
                  <div className="bg-light bg-opacity-25 rounded p-2">
                    <RefreshCw size={24} className="text-white" />
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <span className="badge bg-light text-info fw-semibold me-2">
                    <ArrowUp size={14} className="me-1" />
                    {dashboardData.purchaseReturnGrowth || 0}%
                  </span>
                  <span className="text-white-50 small">vs last month</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Row 2 - Profit & Sales/Purchase Chart */}
        <div className="row g-3 mb-4">
          {/* Profit Card */}
          <div className="col-xl-3 col-sm-6">
            <div className="card h-100">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="mb-0">Net Profit</h6>
                  <span className="badge bg-danger bg-opacity-10 text-danger px-3 py-2 rounded-pill">
                    {dashboardData.profitGrowth || 0}% vs Last Month
                  </span>
                </div>
                <h2 className="mb-0">{formatCurrency(dashboardData.totalProfit)}</h2>
                <div className="mt-3">
                  <Link to="/profit-loss-report" className="text-primary text-decoration-none">
                    View All →
                  </Link>
                </div>

                <div className="mt-4">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="text-muted">Total Purchase</span>
                    <span className="fw-bold">{formatCompactNumber(dashboardData.totalPurchase)}</span>
                  </div>
                  <div className="progress mb-3" style={{ height: '6px' }}>
                    <div className="progress-bar bg-warning" style={{ width: dashboardData.totalPurchase ? '70%' : '0%' }}></div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="text-muted">Total Sales</span>
                    <span className="fw-bold">{formatCompactNumber(dashboardData.totalSales)}</span>
                  </div>
                  <div className="progress" style={{ height: '6px' }}>
                    <div className="progress-bar bg-success" style={{ width: dashboardData.totalSales ? '85%' : '0%' }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Sales & Purchase Chart */}
          <div className="col-xl-6 col-sm-12">
            <div className="card h-100">
              <div className="card-header bg-transparent border-0 d-flex justify-content-between align-items-center pt-3">
                <h5 className="mb-0">Sales & Purchase</h5>
                <div className="d-flex gap-3">
                  <div className="d-flex align-items-center gap-2">
                    <span className="badge bg-warning" style={{ width: '12px', height: '12px', borderRadius: '50%' }}></span>
                    <small>Total Purchase</small>
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span className="badge bg-success" style={{ width: '12px', height: '12px', borderRadius: '50%' }}></span>
                    <small>Total Sales</small>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <Chart
                  options={salesPurchaseChartOptions}
                  series={salesPurchaseChartOptions.series}
                  type="area"
                  height={250}
                />
              </div>
            </div>
          </div>

          {/* Overall Information */}
          <div className="col-xl-3 col-sm-12">
            <div className="card h-100">
              <div className="card-header bg-transparent border-0 pt-3">
                <h5 className="mb-0">Overall Information</h5>
              </div>
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <div>
                    <p className="text-muted mb-1">Suppliers</p>
                    <h3 className="mb-0">{dashboardData.totalSuppliers}</h3>
                  </div>
                  <div className="bg-primary bg-opacity-10 rounded p-3">
                    <Truck size={24} className="text-primary" />
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between mb-4">
                  <div>
                    <p className="text-muted mb-1">Customer</p>
                    <h3 className="mb-0">{dashboardData.totalCustomers}</h3>
                  </div>
                  <div className="bg-success bg-opacity-10 rounded p-3">
                    <Users size={24} className="text-success" />
                  </div>
                </div>

                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <p className="text-muted mb-1">Orders</p>
                    <h3 className="mb-0">{dashboardData.totalOrders}</h3>
                  </div>
                  <div className="bg-info bg-opacity-10 rounded p-3">
                    <ShoppingBag size={24} className="text-info" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Row 3 - Customers Overview & Top Selling Products */}
        <div className="row g-3 mb-4">
          {/* Customers Overview */}
          <div className="col-xl-3 col-sm-6">
            <div className="card h-100">
              <div className="card-header bg-transparent border-0 pt-3">
                <h5 className="mb-0">Customers Overview</h5>
              </div>
              <div className="card-body">
                <div className="text-center mb-4">
                  <div className="position-relative d-inline-block">
                    <div className="display-1 fw-bold text-primary">{formatCompactNumber(dashboardData.newCustomers)}</div>
                    <span className="position-absolute top-0 start-100 translate-middle badge bg-success rounded-pill">
                      New
                    </span>
                  </div>
                  <p className="text-muted">First Time Customers</p>
                </div>

                <div className="text-center">
                  <div className="display-1 fw-bold text-warning">{formatCompactNumber(dashboardData.returningCustomers)}</div>
                  <p className="text-muted">Returning Customers</p>
                </div>

                <div className="mt-4">
                  <div className="d-flex justify-content-between mb-2">
                    <span className="text-muted">Retention Rate</span>
                    <span className="fw-bold">72%</span>
                  </div>
                  <div className="progress" style={{ height: '8px' }}>
                    <div className="progress-bar bg-success" style={{ width: '72%' }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Top Selling Products */}
          <div className="col-xl-6 col-sm-12">
            <div className="card h-100">
              <div className="card-header bg-transparent border-0 d-flex justify-content-between align-items-center pt-3">
                <h5 className="mb-0">Top Selling Products</h5>
                <div className="btn-group" role="group">
                  <button
                    className={`btn btn-sm ${selectedPeriod === 'weekly' ? 'btn-primary' : 'btn-outline-secondary'}`}
                    onClick={() => handlePeriodChange('weekly')}
                  >
                    Weekly
                  </button>
                  <button
                    className={`btn btn-sm ${selectedPeriod === 'monthly' ? 'btn-primary' : 'btn-outline-secondary'}`}
                    onClick={() => handlePeriodChange('monthly')}
                  >
                    Monthly
                  </button>
                  <button
                    className={`btn btn-sm ${selectedPeriod === 'yearly' ? 'btn-primary' : 'btn-outline-secondary'}`}
                    onClick={() => handlePeriodChange('yearly')}
                  >
                    Yearly
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-hover align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>Product Name</th>
                        <th className="text-end">Price</th>
                        <th className="text-end">Growth</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboardData.topSellingProducts?.length > 0 ? (
                        dashboardData.topSellingProducts.map((product, index) => (
                          <tr key={index}>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="avatar avatar-md bg-dark rounded me-3">
                                  <Package size={20} />
                                </div>
                                <div>
                                  <h6 className="mb-0">{product.name}</h6>
                                </div>
                              </div>
                            </td>
                            <td className="text-end fw-bold">{formatCurrency(product.price)}</td>
                            <td className="text-end">
                              <span className="badge bg-success bg-opacity-10 text-success fw-semibold px-3 py-2">
                                <ArrowUp size={14} className="me-1" />
                                {product.growth || 0}%
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center text-muted py-3">
                            No top selling products data
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* Low Stock Products */}
          <div className="col-xl-3 col-sm-12">
            <div className="card h-100 border-warning">
              <div className="card-header bg-transparent border-0 d-flex justify-content-between align-items-center pt-3">
                <h5 className="mb-0 text-warning">Low Stock Products</h5>
                <span className="badge bg-warning">Alert</span>
              </div>
              <div className="card-body">
                <div className="list-group list-group-flush">
                  {dashboardData.lowStockProducts?.length > 0 ? (
                    dashboardData.lowStockProducts.map((product, index) => (
                      <div key={index} className="list-group-item px-0 border-0">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h6 className="mb-1">{product.name}</h6>
                            <small className="text-muted">ID: {product.sku}</small>
                          </div>
                          <div className="text-end">
                            <span className="badge bg-danger mb-2">{product.stock} left</span>
                            <br />
                            <small className="text-muted">Alert: {product.alert}</small>
                          </div>
                        </div>
                        {index < dashboardData.lowStockProducts.length - 1 && <hr className="my-2" />}
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-muted py-3">
                      <CheckCircle size={24} className="text-success mb-2" />
                      <p>All products have sufficient stock</p>
                    </div>
                  )}
                </div>
                {/* <div className="mt-3">
                  <Link to="/products/low-stock" className="btn btn-outline-warning w-100">
                    View All Low Stock
                  </Link>
                </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* Row 4 - Recent Sales, Sales Statistics, Recent Transactions */}
        <div className="row g-3 mb-4">
          {/* Recent Sales */}
          <div className="col-xl-4 col-sm-12">
            <div className="card h-100">
              <div className="card-header bg-transparent border-0 d-flex justify-content-between align-items-center pt-3">
                <h5 className="mb-0">Recent Sales</h5>
                <Link to="/sales-list" className="text-primary">View All</Link>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead className="table-light">
                      <tr>
                        <th>Product</th>
                        <th>Category</th>
                        <th className="text-end">Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dashboardData.recentSales?.length > 0 ? (
                        dashboardData.recentSales.map((sale, index) => (
                          <tr key={index}>
                            <td>
                              <div>
                                <h6 className="mb-0">{sale.product || sale.product_name}</h6>
                                <small className="text-muted">{sale.customer}</small>
                              </div>
                            </td>
                            <td>
                              <span className="badge bg-light text-dark">{sale.category || 'N/A'}</span>
                            </td>
                            <td className="text-end fw-bold">{formatCurrency(sale.price || sale.amount)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center text-muted py-3">
                            No recent sales
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* Payment Overview */}
          <div className="col-xl-4 col-sm-12">
            <div className="card h-100">
              <div className="card-header bg-transparent border-0 d-flex justify-content-between align-items-center pt-3">
                <h5 className="mb-0">Payment Overview</h5>
                <Link to="/sales-list" className="text-primary small">View All</Link>
              </div>
              <div className="card-body">
                {/* Top 2 stat boxes */}
                <div className="row g-2 mb-3">
                  <div className="col-6">
                    <div className="rounded p-2 text-center" style={{ background: '#e8f5e9' }}>
                      <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>Paid Amount</p>
                      <h6 className="text-success mb-0 fw-bold">{formatCurrency(dashboardData.salesPaymentSummary?.totalPaid)}</h6>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="rounded p-2 text-center" style={{ background: '#fff3e0' }}>
                      <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>Due Amount</p>
                      <h6 className="text-warning mb-0 fw-bold">{formatCurrency(dashboardData.salesPaymentSummary?.totalDue)}</h6>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="rounded p-2 text-center" style={{ background: '#e3f2fd' }}>
                      <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>Avg Order Value</p>
                      <h6 className="text-primary mb-0 fw-bold">{formatCurrency(dashboardData.salesPaymentSummary?.avgOrderValue)}</h6>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="rounded p-2 text-center" style={{ background: '#f3e5f5' }}>
                      <p className="text-muted mb-1" style={{ fontSize: '0.75rem' }}>Total Invoiced</p>
                      <h6 className="text-purple mb-0 fw-bold" style={{ color: '#7b1fa2' }}>{formatCurrency(dashboardData.salesPaymentSummary?.totalInvoiced)}</h6>
                    </div>
                  </div>
                </div>

                {/* Collection rate bar */}
                <div className="mb-3">
                  <div className="d-flex justify-content-between mb-1">
                    <small className="text-muted">Collection Rate</small>
                    <small className="fw-bold text-success">{dashboardData.salesPaymentSummary?.collectionRate ?? 0}%</small>
                  </div>
                  <div className="progress" style={{ height: '8px', borderRadius: '4px' }}>
                    <div
                      className="progress-bar bg-success"
                      style={{ width: `${dashboardData.salesPaymentSummary?.collectionRate ?? 0}%`, borderRadius: '4px' }}
                    />
                  </div>
                </div>

                {/* Order status pills */}
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge rounded-pill px-3 py-2" style={{ background: '#e8f5e9', color: '#2e7d32', fontSize: '0.78rem' }}>
                    Paid &nbsp;<strong>{dashboardData.salesPaymentSummary?.paidOrders ?? 0}</strong>
                  </span>
                  <span className="badge rounded-pill px-3 py-2" style={{ background: '#fff3e0', color: '#e65100', fontSize: '0.78rem' }}>
                    Partial &nbsp;<strong>{dashboardData.salesPaymentSummary?.partialOrders ?? 0}</strong>
                  </span>
                  <span className="badge rounded-pill px-3 py-2" style={{ background: '#fce4ec', color: '#b71c1c', fontSize: '0.78rem' }}>
                    Unpaid &nbsp;<strong>{dashboardData.salesPaymentSummary?.unpaidOrders ?? 0}</strong>
                  </span>
                  <span className="badge rounded-pill px-3 py-2" style={{ background: '#e3f2fd', color: '#1565c0', fontSize: '0.78rem' }}>
                    Delivered &nbsp;<strong>{dashboardData.salesPaymentSummary?.deliveredOrders ?? 0}</strong>
                  </span>
                  <span className="badge rounded-pill px-3 py-2" style={{ background: '#f5f5f5', color: '#616161', fontSize: '0.78rem' }}>
                    Pending &nbsp;<strong>{dashboardData.salesPaymentSummary?.pendingOrders ?? 0}</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Transactions */}
          <div className="col-xl-4 col-sm-12">
            <div className="card h-100">
              <div className="card-header bg-transparent border-0 d-flex justify-content-between align-items-center pt-3">
                <h5 className="mb-0">Recent Transactions</h5>
                {/* <Link to="/transactions" className="text-primary">View All</Link> */}
              </div>
              <div className="card-body">
                <div className="timeline-vertical">
                  {dashboardData.recentTransactions?.length > 0 ? (
                    dashboardData.recentTransactions.map((transaction, index) => (
                      <div key={index} className="timeline-item d-flex align-items-start mb-3">
                        <div className="timeline-icon me-3">
                          <div className={`rounded-circle p-2 ${getStatusBadge(transaction.status)} bg-opacity-10`}>
                            {transaction.status?.toLowerCase() === 'completed' || transaction.status?.toLowerCase() === 'paid' ?
                              <CheckCircle size={16} className="text-success" /> :
                              <Clock size={16} className="text-warning" />
                            }
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <div className="d-flex justify-content-between">
                            <h6 className="mb-1">{transaction.customer || transaction.party_name}</h6>
                            <small className="text-muted">{transaction.date_formatted || transaction.date}</small>
                          </div>
                          <div className="d-flex justify-content-between align-items-center">
                            <small className="text-muted">ID: {transaction.invoiceId || transaction.reference}</small>
                            <span className={`badge ${getStatusBadge(transaction.status)}`}>
                              {transaction.status}
                            </span>
                          </div>
                          <div className="mt-1">
                            <span className="fw-bold">{formatCurrency(transaction.amount)}</span>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center text-muted py-3">
                      No recent transactions
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Row 5 - Top Customers & Categories */}
        <div className="row g-3">
          {/* Top Customers */}
          <div className="col-xl-8 col-sm-12">
            <div className="card">
              <div className="card-header bg-transparent border-0 d-flex justify-content-between align-items-center pt-3">
                <h5 className="mb-0">Top Customers</h5>
                <Link to="/customers" className="text-primary">View All</Link>
              </div>
              <div className="card-body">
                <div className="row">
                  {dashboardData.topCustomers?.length > 0 ? (
                    dashboardData.topCustomers.map((customer, index) => (
                      <div className="col-xl-3 col-sm-6 mb-3" key={index}>
                        <div className="card border-0 bg-light">
                          <div className="card-body text-center">
                            <div className="avatar avatar-xl bg-primary bg-opacity-10 rounded-circle mb-3 mx-auto d-flex align-items-center justify-content-center">
                              <Users size={32} className="text-primary" />
                            </div>
                            <h6 className="mb-1">{customer.name}</h6>
                            <p className="text-muted small mb-2">
                              <MapPin size={12} className="me-1" />
                              {customer.country || customer.address || 'N/A'}
                            </p>
                            <div className="d-flex justify-content-center gap-3">
                              <div className="text-center">
                                <small className="text-muted d-block">Orders</small>
                                <span className="fw-bold">{customer.orders}</span>
                              </div>
                              <div className="text-center">
                                <small className="text-muted d-block">Spent</small>
                                <span className="fw-bold">{formatCompactNumber(customer.total_spent || customer.amount)}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="col-12 text-center text-muted py-3">
                      No top customers data
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Categories */}
          <div className="col-xl-4 col-sm-12">
            <div className="card h-100">
              <div className="card-header bg-transparent border-0 pt-3">
                <h5 className="mb-0">Categories</h5>
              </div>
              <div className="card-body">
                <div className="text-center mb-4">
                  <div className="bg-primary bg-opacity-10 rounded-circle p-4 d-inline-flex mb-3">
                    <Package size={48} className="text-primary" />
                  </div>
                  <h6 className="text-muted mb-2">Total Number of Categories</h6>
                  <h2 className="display-4 fw-bold text-primary mb-0">{dashboardData.categoryStats?.totalCategories || 0}</h2>
                </div>

                <div className="text-center">
                  <div className="bg-success bg-opacity-10 rounded-circle p-4 d-inline-flex mb-3">
                    <ShoppingBag size={48} className="text-success" />
                  </div>
                  <h6 className="text-muted mb-2">Total Number of Products</h6>
                  <h2 className="display-4 fw-bold text-success mb-0">{dashboardData.categoryStats?.totalProducts || 0}</h2>
                </div>

                <div className="mt-4">
                  <Link to="/category-list" className="btn btn-outline-primary w-100">
                    Manage Categories
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </div>
  );
};

export default Dashboard;